<template>
  <!--导航栏-->
  <div class="top" :class="{ 'dark':dark }">
    <div class="ktmlogo">
      <img v-if="dark" src="../../assets/images/logo-white.png" />
      <img v-else src="../../assets/images/logo.png" />
    </div>
    <div class="title">
      <ul>
        <li v-for="item in menu_items" :key="item.name">
          <a :href="item.path" :class="{active: item.active}">{{item.name}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      menu_items: [
        { name: "首页", path: "/index", active: true },
        // { name: "案例", path: "#", active: false },
        { name: "产品", path: "/product", active: false },
        { name: "新闻", path: "/news", active: false },
        { name: "关于", path: "/aboutus", active: false }
        // { name: "合作", path: "#", active: false }
      ]
    };
  },

  methods: {},

  mounted() {
    // console.log(this.$router);
  },

  computed: {
    dark() {
      // return this.$route.path === "/" || this.$route.path === "/index";
      return true;
    }
  },

  watch: {
    $route(val) {
      // console.log(111111, "watch.$route", this.$route);
      this.menu_items.forEach(m => (m.active = false));

      let active_item = this.menu_items.find(m =>
        this.$router.currentRoute.path.startsWith(m.path)
      );
      // console.log(222222, active_item.path);
      if (active_item) {
        active_item.active = true;
      }
    }
  }
};
</script>
  
<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

$SIZE_TOP_HEIGHT: 0.39rem;

.top {
  display: flex;
  justify-content: space-between;
  // width: 100%;
  height: $SIZE_TOP_HEIGHT;
  background-color: white;
  opacity: 0.7;

  > .ktmlogo {
    display: inline;
    box-sizing: content-box;
    padding-left: $SIZE_PAGE_MARGING;
    line-height: $SIZE_TOP_HEIGHT;

    > img {
      width: 0.543rem;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }

  > .title {
    padding-right: $SIZE_PAGE_MARGING;
    text-align: right;

    ul {
      display: flex;
      list-style-type: none;

      li {
        width: 60px;
        height: 56px;

        a {
          color: #848789;
          text-decoration: none;
          line-height: $SIZE_TOP_HEIGHT;
        }

        a.active {
          color: #0092d8;
          cursor: default;
        }
      }

      a:hover {
        color: #0ab2d2;
      }
    }
  }

  &.dark {
    background-color: rgba(0, 0, 0, 1);
    > .title {
      a.active {
        color: #ffffff;
      }

      a:hover {
        color: #dddddd;
      }
    }
  }
}
</style>